import { defineSlotRecipe } from "@chakra-ui/react";

export const toastSlotRecipe = defineSlotRecipe({
  base: {
    root: {
      bg: "bg.inverted",
      borderRadius: "2xl",
      color: "fg.inverted",
    },
    title: {
      textStyle: "body2",
    },
  },
  slots: [
    "root",
    "title",
    "description",
    "indicator",
    "closeTrigger",
    "actionTrigger",
  ],
});
